export default __webpack_public_path__ + "static/media/icon-insta.34a18f53.svg";